/**
 * Created by Vladislav on 03.06.2025.
 */

Mission.TYPE_SPACE_RACE = 77;

Mission.REGISTRATIONS.set(Mission.TYPE_SPACE_RACE, () => ({
    name: "SpaceRace",
    teaser: true,
    view: SpaceRaceWindow,
    startWindow: SpaceRaceStartWindow,
    logic: SpaceRaceMissionLogic,
    schedule: "FRI-MON",
    semaphore: Mission.SEMAPHORE_ALWAYS,
    abTest: () => {
        if (cleverapps.config.name === "ladacha") {
            return cleverapps.abExperiments.getGroup(ABExperiments.Tests.ladachaLiveOps) === "A";
        }
        return true;
    },
    available: cleverapps.config.availables.SPACE_RACE_MISSION,
    bundle: "space_race",
    guideWindow: {
        name: "SpaceRaceGuideWindow",
        title: "SpaceRaceGuideWindow.title",
        bundle: bundles.space_race_guide_window
    },
    prize: RewardsConfig.SpaceRace,
    collectIcon: bundles.reward_icons.frames.race_reward,
    oneWinner: true,
    prepareRewardByRich: false,
    sideBarPlace: false,
    sideBarProgressBar: {
        bar: bundles.progress_bar.frames.bar_spacerace,
        bg: bundles.progress_bar.frames.bg_spacerace
    },
    sideBarJson: function (model) {
        const stage = model.mission ? model.mission.logic.getStage() : 0;
        return bundles.sidebar.jsons[`space_race_stage${stage}_icon_json`];
    },
    rowView: cleverapps.config.type === "merge2" ? function (row) {
        return Prefab.instantiate(bundles.merge.jsons.space_race_row_prefab_json, { mission: row.data.mission });
    } : undefined,
    competition: cleverapps.config.type === "merge2" ? {
        withScrollTable: false,
        algo: PersonalBestBotAlgorithm,
        avgSpeed: "spacerace",
        speedType: PersonalBestBotAlgorithm.SpeedType.PerMinute,
        forceCoef: [50, 130]
    } : {
        withScrollTable: false,
        averageProcessTimeout: cleverapps.parseInterval("5 minutes"),
        forceCoef: 0.5,
        botAheadPlayerCoef: 0.8,
        offlineCoef: 0.8,
        botAheadPlayerBigDifferenceCoef: 0.5,
        bigDistanceLength: 1
    },
    stages: [
        { target: 3, maxResult: 3, amount: 4 },
        { target: 5, maxResult: 5, amount: 3 },
        { target: 7, maxResult: 7, amount: 2 }
    ]
}));